import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { PeriodResponse } from "./interface";
import { PeriodFormPayload } from "./validation";

// get
const getPeriod = async (
  query?: string
): Promise<ApiResponse<DataPaginate<PeriodResponse>>> => {
  return await fetcher(query ? `master/periode?${query}` : `master/periode`);
};

export const useGetPeriod = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<PeriodResponse>>, Error>(
    ["useGetPeriod", query],
    () => getPeriod(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};

// get by id
export const getPeriodId = async (
  id: number
): Promise<ApiResponse<DataObject<PeriodResponse>>> => {
  return await fetcher(`master/periode/${id}`);
};

export const useGetPeriodId = (id: number) => {
  return useQuery<ApiResponse<DataObject<PeriodResponse>>, Error>(
    ["useGetPeriodId", id],
    () => getPeriodId(id)
  );
};

// post
export const usePeriod = (method: "POST" | "PUT" = "POST", id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<PeriodResponse>>,
    Error,
    PeriodFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<PeriodResponse>>> => {
      const endpoint = id ? `master/periode/${id}` : "master/periode";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<PeriodResponse>> = await sendData(
        endpoint,
        data,
        method
      );
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};
